"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import useMediaQuery from "@/hooks/useMediaQuery";
import CompatibleDevices from "./CompatibleDevices";

interface CheckCompatibilityModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDevice: React.Dispatch<React.SetStateAction<string>>;
}

function CheckCompatibilityModal({
  open,
  setOpen,
  setShowSuccessModal,
  setSelectedDevice,
}: CheckCompatibilityModalProps) {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop)
    return (
      <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
        {/* <DialogTrigger className="flex items-center gap-2 transition-colors hover:cursor-pointer hover:text-primary"></DialogTrigger> */}
        <DialogContent className="flex flex-col gap-3 sm:gap-5">
          <CompatibleDevices
            setSelectedDevice={setSelectedDevice}
            setShowSuccessModal={setShowSuccessModal}
            setOpen={setOpen}
          />
        </DialogContent>
      </Dialog>
    );

  return (
    <Drawer open={open} onOpenChange={setOpen} repositionInputs={false}>
      {/* <DrawerTrigger className="flex items-center gap-2 transition-colors hover:cursor-pointer hover:text-primary"></DrawerTrigger> */}
      <DrawerContent className="flex flex-col gap-3 p-3 sm:gap-5">
        <CompatibleDevices
          setSelectedDevice={setSelectedDevice}
          setShowSuccessModal={setShowSuccessModal}
          setOpen={setOpen}
        />
      </DrawerContent>
    </Drawer>
  );
}

export default CheckCompatibilityModal;
